import { Record } from 'immutable';

import { GridListEntity } from '../components/grid-list/grid-list.entity';

export const GridSliceKey = 'main';

export interface IGridOriginalSliceState {
	loading: boolean;
	list: GridListEntity;
	deleteSuccess: boolean;
}

export const defaults: IGridOriginalSliceState = {
	loading: false,
	list: GridListEntity.build([]),
	deleteSuccess: false,
};

export class GridOriginalSliceState extends Record<IGridOriginalSliceState>(
	defaults
) {
	public static readonly key = GridSliceKey;

	public setLoading(isLoading: boolean): GridOriginalSliceState {
		return this.set('loading', isLoading);
	}

	public setGridList(gridList: GridListEntity): GridOriginalSliceState {
		return this.set('list', gridList);
	}

	public setDeleteSuccess(isSuccess: boolean): GridOriginalSliceState {
		return this.set('deleteSuccess', isSuccess);
	}
}
